import React from "react"
import { storyblokEditable } from "@storyblok/react"
import { useStaticQuery, graphql } from "gatsby"

import { ContactViaMailContainer } from "gatsby-theme-gba"

const ContactViaMailContainerEditable = ({ blok }) => {
  const defaultLang = process.env.GATSBY_DEFAULT_LANG
    ? process.env.GATSBY_DEFAULT_LANG
    : "de"

  const label = "Sie können uns über diese E-Mail-Adresse kontaktieren"

  const contacts = useStaticQuery(graphql`
    query ContactsQuery {
      allStoryblokEntry(
        filter: { default_full_slug: { regex: "/^contact-settings/" } }
      ) {
        nodes {
          uuid
          lang
          content
        }
      }
      fallback: allStoryblokEntry(
        filter: { full_slug: { regex: "/^contact-settings/" } }
      ) {
        nodes {
          uuid
          lang
          content
        }
      }
    }
  `)

  let mailListing = []

  if (contacts.allStoryblokEntry.nodes.length > 0) {
    const currentLang =
      blok.currentLanguage === defaultLang ? "default" : blok.currentLanguage
    const id = blok.config

    const item = contacts.allStoryblokEntry.nodes.find(
      (node) => node.uuid === id && node.lang == currentLang
    )

    mailListing = JSON.parse(item.content).departments.map((item) => {
      return {
        id: item._uid,
        department: item.department,
        email: item.email.url,
        emailText: item.emailText,
      }
    })

    if (blok.ghost) {
      mailListing = [
        { department: `${blok.ghost} *`, email: "", emailText: "" },
      ].concat(mailListing)
    }
  }

  return (
    <ContactViaMailContainer
      {...storyblokEditable(blok)}
      key={blok._uid}
      heading={blok.heading}
      label={label}
      mailListing={mailListing}
      required={blok.required}
    />
  )
}

export default ContactViaMailContainerEditable
